import './App.css';
import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Button, notification } from 'antd';
import HomePage from './pages/Home';
import OrdersPage from './pages/Orders';
import NotificationPage from './pages/Notification';
import LogPage from './pages/Log';
import FilesPage from './pages/Files';
import LoginPage from './pages/Login';
import HeaderMenu from './components/HeaderMenu';
import ImportPopUp from './components/ImportPopUp';
import { useUser } from './UserContext';
import VisitorOrdersPage from './pages/VisitorOrder';
import { isTokenExpired } from './conf/config';
import AddOrderPop from './components/AddOrdersPop';
import { getCookie, setCookie, deleteCookie } from './conf/config';
import { OrderProvider } from './OrdersContext';
import { BASE_URL } from './conf/config';

import FileUploadPop from './components/FileUploadPop';
import StwxeCheckerPop from './components/StwxeCheckerPop';
import PrehSAPop from './components/PrehSAPop';
import HelpSpotlight from './components/HelpSpotlight';
const { Header, Content } = Layout;

notification.config({ duration: 0 });

function App() {
  // State for managing the import modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);
  // State to track if the user is authenticated — init synchronously so the
  // first render is already correct (avoids flash/redirect in new windows like /help)
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = getCookie('access_token');
    return !!(token && !isTokenExpired(token));
  });
  // Retrieve user information from UserContext
  const { userGroups, orders, fetchWithAuth, username } = useUser();
  // Reference to the Add Order modal component
  const addOrderModalRef = useRef(null);
  // file for parse pdf
  const fileInputRef = useRef(null); // hide the file input

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      notification.info({
        message: "File Uploaded",
        description: `The file "${file.name}" is being parsed. Please wait...`,
      });
      handleParseDoc(file); // send parse request to backend
    }
  };

  const handleParseDoc = (file) => {
    if (!file) {
      notification.error({
        message: "Error",
        description: "Please select a file before parsing.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    fetchWithAuth(`${BASE_URL}/api/parse/`, {
      method: "POST",
      body: formData, // 
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to parse the document.");
        }
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          notification.success({
            message: "Success",
            description: `The file "${file.name}" was parsed successfully!`,
          });
          console.log("Parsed Content:", data.content); // debug
        } else {
          notification.error({
            message: "Error",
            description: data.error || "Unknown error occurred.",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        notification.error({
          message: "Error",
          description: "Failed to parse the document. Please try again later.",
        });
      });
  };


  // const triggerFileUpload = () => {
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click(); // trigger the file input click event
  //   }
  // };

  // Check authentication status on initial render
  useEffect(() => {
	  console.log("=== INNOCOSO REACT RUNTIME LOG START ===");
console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("window.origin:", window.origin);
console.log("window.location.href:", window.location.href);
console.log("window.location.hostname:", window.location.hostname);
console.log("window.location.pathname:", window.location.pathname);
console.log("window.location.search:", window.location.search);
console.log("=== INNOCOSO REACT RUNTIME LOG END ===");


    const token = getCookie('access_token');
    if (token && !isTokenExpired(token)) {
      // Set authenticated if token is valid
      setIsAuthenticated(true);
    } else {
      // If no valid token, clear authentication and remove tokens
      setIsAuthenticated(false);
      deleteCookie('access_token');
      deleteCookie('refresh_token');
    }
	
  }, []);

  // Open the import modal when "Import" button is clicked
  function handleImport() {
    setIsModalOpen(true);
  }

  // Handle user logout
  function handleLogout() {
    deleteCookie('access_token');
    deleteCookie('refresh_token');
    setIsAuthenticated(false);
  }

  // Handle adding a new order by opening Add Order modal
  function handAddOrder() {
    addOrderModalRef.current.open();
    // Retrieve keys from the first order to initialize a new order object
    const keys = Object.keys(orders[0]);
    console.log("keys:", keys);

    // Create a new empty order object
    const newOrder = keys.reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});

    // Remove the id field from the new order object
    delete newOrder.id;
    console.log("create a new order:", newOrder);
    // Set the new order to the AddOrderPop component
    addOrderModalRef.current.setInvoiceOrders([newOrder]);
  }

  // Check if current path is a media path to conditionally render components
  const isMediaPath = window.location.pathname.startsWith('/media');

  if (isMediaPath) {
    return null; // Render nothing for media paths
  }

  return (
    <Router>
      <OrderProvider>
        <Layout className="layout">
          {isAuthenticated ? (
            <>
              <Header className="layout-header">
                <div style={{ flex: 1, minWidth: 0 }}>
                  <HeaderMenu />
                </div>
                <div className="header-buttons">
                  {userGroups.includes('admin') ? (
                    <>
                      <FileUploadPop />
		                 <StwxeCheckerPop />
                     <PrehSAPop />
                      {/* hidden input for files */}
                      {/* <input
                        type="file"
                        accept="application/pdf"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      <Button type="primary" className="header-button" onClick={triggerFileUpload}>
                        Check invoices
                      </Button> */}

                      <span data-help-id="import-button">
                      <Button type="primary" className="header-button" onClick={handleImport}>
                        Import
                      </Button>
                      </span>
                      <span data-help-id="add-order-button">
                      <Button type="primary" className="header-button" onClick={handAddOrder}>
                        Add order
                      </Button>
                      </span>
                      <Button shape="circle" className="header-button" onClick={() => window.open('/help', 'innocoso-help', 'width=700,height=820,left=0,top=0')} title="Help">?</Button>
                      <Button type="primary" className="header-button" onClick={handleLogout} danger>
                        Logout
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button shape="circle" className="header-button" onClick={() => window.open('/help', 'innocoso-help', 'width=700,height=820,left=0,top=0')} title="Help">?</Button>
                      <Button type="primary" className="header-button" onClick={handleLogout} danger>
                        Logout
                      </Button>
                    </>
                  )}
                </div>
                {username && (
                  <span style={{ color: '#aaa', fontSize: 13, flexShrink: 0, whiteSpace: 'nowrap' }}>
                    {username}
                  </span>
                )}
              </Header>
              <Content style={{ padding: '0 50px' }}>
                <div className="site-layout-content" style={{ marginTop: '20px' }}>
                  <Routes>
                    {/* Conditionally render routes based on user groups */}
                    {userGroups.includes('visitors') ? (
                      <>
                        <Route path="/" element={<OrdersPage />} />
                        <Route path="/orders" element={<VisitorOrdersPage />} />
                        <Route path="/log" element={<LogPage />} />
                        <Route path="/files" element={<FilesPage />} />
                        <Route path="*" element={<Navigate to="/" />} />
                      </>
                    ) : (
                      <>
                        <Route path="/" element={<OrdersPage />} />
                        <Route path="/home" element={<HomePage />} />
                        <Route path="/orders" element={<OrdersPage />} />
                        <Route path="/notifications" element={<NotificationPage />} />
                        <Route path="/log" element={<LogPage />} />
                        <Route path="/files" element={<FilesPage />} />
                        <Route path="*" element={<Navigate to="/" />} />
                      </>
                    )}
                  </Routes>
                </div>
              </Content>
              {/* Modals for import and adding orders */}
              <ImportPopUp isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
              <AddOrderPop ref={addOrderModalRef} />
              <HelpSpotlight />
            </>
          ) : (
            // If not authenticated, render login route
            <Routes>
              <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          )}
        </Layout>
      </OrderProvider>
    </Router>
  );
}



export default App;
